document.addEventListener('DOMContentLoaded', function() {
  const snowContainer = document.querySelector('.snow-container');
  const snowflakeCount = 80;
  
  // Create snowflakes
  for (let i = 0; i < snowflakeCount; i++) {
    createSnowflake();
  }
  
  function createSnowflake() {
    const snowflake = document.createElement('div');
    snowflake.className = 'snowflake';
    
    // Random starting position anywhere in container
    const startingX = Math.random() * window.innerWidth;
    const startingY = Math.random() * snowContainer.offsetHeight;
    
    // Random size between 1px and 3px
    const size = Math.random() * 2 + 1;
    
    // Fixed slow speed for all snowflakes
    const speed = 0.15;
    let currentY = startingY;
    let currentX = startingX;
    let lastY = currentY; // Track last Y position to prevent upward movement
    
    // Set initial position and size
    snowflake.style.width = size + 'px';
    snowflake.style.height = size + 'px';
    
    // Add to container
    snowContainer.appendChild(snowflake);
    
    // Animate the snowflake
    function animate() {
      lastY = currentY;
      currentY += speed;
      currentX += Math.sin(currentY * 0.01) * 0.2;
      
      // Reset if snowflake goes below container
      if (currentY > snowContainer.offsetHeight) {
        currentY = -5;
        currentX = Math.random() * window.innerWidth;
        // Ensure smooth transition by setting transform before changing position
        snowflake.style.transition = 'none';
        snowflake.style.transform = `translate(${currentX}px, -5px)`;
        // Force a repaint
        snowflake.offsetHeight;
        // Restore transition
        snowflake.style.transition = 'transform 0.016s linear';
      }
      
      // Only update if moving downward
      if (currentY >= lastY) {
        snowflake.style.transform = `translate(${currentX}px, ${currentY}px)`;
      }
      
      requestAnimationFrame(animate);
    }
    
    animate();
  }
});